import React from 'react';
import useCustomNavigate from '../../../hooks/useCustomNavigate';

const PremiumServices = ({ setHoveredItem }) => {
  const { goTo } = useCustomNavigate();

  const services = [
    { name: 'Interior Designer', description: 'This is a premium service.' },
    { name: 'Vastu Facilities', description: 'This is another premium service.' },
    { name: 'Home Services', description: 'This is a third premium service.' },
    { name: 'Movers & Packers', description: 'This is a fourth premium service.' },
    { name: 'Legal Team', description: 'This is a fifth premium service.' },
    { name: 'Modular Kitchens', description: 'This is a sixth premium service.' },
    { name: 'Construction Companies', description: 'This is a seventh premium service.' },
    { name: 'Furniture', description: 'This is an eighth premium service.' }
  ];

  return (
    <div className="relative bg-white p-6 rounded-b-lg shadow-md border-b-2 border-l-2 border-r-2 border-gray-400">
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Buy Services</h3>

      <div className="flex flex-wrap gap-4 max-h-[250px] overflow-y-auto pr-4">
        {services.map((service, index) => (
          <button
            key={index}
            onClick={() => goTo(`/service/list/${service?.name?.replace(/ /g, '-')}`)}
            className="bg-white border border-gray-300 hover:border-green-500 hover:bg-green-50 text-gray-800 hover:text-green-700 py-2 px-4 rounded-md transition duration-200 shadow-sm hover:shadow-md"
          >
            <h5 className="text-sm font-medium">{service.name}</h5>
          </button>
        ))}
      </div>

      {/* Add Services Button - bottom right */}
      <div className="absolute bottom-4 right-6">
        <button
          className="bg-blue-600 text-white py-2 px-5 rounded-md hover:bg-blue-800 transition duration-200"
          onClick={() => {
            goTo("/addservice");
            setHoveredItem("");
          }}
        >
          Add Services
        </button>
      </div>
    </div>
  );
};

export default PremiumServices;
